// Must match ApplicationAction::MAX_FILE_SIZE and ALLOWED_FILE_TYPES
const MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024; // 100MB
const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/png",
  "image/jpg",
  "image/gif",
  "image/jpeg",
  "video/mp4",
  "video/mpeg",
  "video/quicktime",
  "video/x-msvideo",
  "video/x-ms-wmv",
  "video/webm",
];

/**
 * Validate file before upload (matches ApplicationAction model rules).
 * Use before direct upload for application actions.
 * @param {File} file - The file to validate
 * @returns {{ valid: boolean, error?: string }}
 */
export const validateFileBeforeUpload = (file) => {
  if (!file) {
    return { valid: false, error: "No file selected" };
  }
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return { valid: false, error: "File size must be less than 100MB" };
  }
  const type = (file.type || "").toLowerCase();
  const allowed = ALLOWED_FILE_TYPES.some((t) => type === t.toLowerCase());
  if (!allowed) {
    return { valid: false, error: "You can only upload the listed file types" };
  }
  return { valid: true };
};
